// src/data/words.js
export const TEST_WORDS = [
    'hello', 'world', 'typing', 'keyboard', 'mobile', 'speed', 'accuracy', 'test',
    'study', 'input', 'output', 'screen', 'window', 'mouse', 'touch', 'swipe',
    'arrow', 'space', 'shift', 'enter', 'back', 'front', 'round', 'square', 'circle',
    'table', 'graph', 'chart', 'point', 'value', 'mean', 'median', 'error',
    'quick', 'brown', 'fox', 'jump', 'lazy', 'dog', 'alpha', 'beta', 'gamma',
    'delta', 'epsilon', 'river', 'ocean', 'cloud', 'storm', 'snow', 'rain',
    'green', 'blue', 'white', 'black', 'light', 'dark', 'small', 'large', 'tiny',
    'quiet', 'loud', 'early', 'later', 'night', 'day', 'north', 'south', 'east',
    'west', 'stone', 'paper', 'glass', 'steel', 'floor', 'chair', 'house', 'room',
    'phone', 'cable', 'sound', 'music', 'video', 'games'
];
